import { render, staticRenderFns } from "./UploadAttachmentModal.vue?vue&type=template&id=19ff8612&"
import script from "./UploadAttachmentModal.vue?vue&type=script&lang=js&"
export * from "./UploadAttachmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports